import Box from '@mui/material/Box';
import React from 'react';

const ListContent = React.forwardRef<
    HTMLElement,
    {
        data: any;
        overflowState?: boolean;
        setData: any;
        Component: React.ComponentType<any> | React.ReactNode;
        setDisplayCustomerActions?: any;
        singleRowGap?: number;
        setOpenDrawer?: any;
        outsideHooks?:any
    }
>(({ data, setData, Component, setDisplayCustomerActions, overflowState = true, singleRowGap = 1, setOpenDrawer,outsideHooks }, ref) => {
    if (!Component) {
        return <p style={{ color: 'black', textAlign: 'center' }}>ללא תוצאות</p>;
    }

    // Helper function to render the component properly
    const renderComponent = () => {
        if (typeof Component === 'function') {
            return setDisplayCustomerActions ? (
                <Component setOpenDrawer={setOpenDrawer} data={data} setDisplayCustomerActions={setDisplayCustomerActions}  outsideHooks={outsideHooks}/>
            ) : (
                <Component setOpenDrawer={setOpenDrawer} data={data} setData={setData} outsideHooks={outsideHooks}/>
            );
        }
        return Component; // If it's JSX, render it directly
    };

    return (
        <Box
            ref={ref}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '100%',
                overflowY: overflowState ? 'auto' : 'none',
                gap: singleRowGap,
                padding: singleRowGap !== 1 ? '8px 0px 0px 0px' : 1,
                '&::-webkit-scrollbar': { display: 'none' }
            }}
        >
            {renderComponent()}
        </Box>
    );
});

export default ListContent;
